// extracted by mini-css-extract-plugin
export default {"checkbox":"SelectQuestion_checkbox__SEYzE","option":"SelectQuestion_option__ajOvY","question":"SelectQuestion_question__ZiDf2"};